import { createContext } from 'react';

// Width (px) of the .famewall-embed container. The real iframe renderers
// respond to the iframe viewport width; with no iframe here we feed the
// container width into the same useMediaQuery breakpoints via the
// react-responsive shim so the layout matches.
export const ContainerWidthContext = createContext(0);
